import { IAdpDonor, IAdpVoucherHolder } from '@nkr/models/index';
import { Alert, Button, Modal, Table } from 'react-bootstrap';
import { ConfirmAction } from './confirm-action';
import DonationTypeRenderer from './render-donation-type';
import { ConfirmTableWrapper } from './styles';

interface IProps {
    show: boolean,
    title: string,
    message: string,
    list: IAdpDonor[] | IAdpVoucherHolder[],
    action: ConfirmAction,
    onYes: () => void,
    onNo: () => void
}

const ConfirmPrint = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.list?.length > 500 &&
                <Alert bsStyle='danger'>Only the first 500 items will be placed into the first document.</Alert>
                }
                <div style={{ marginBottom: 5 }}>The following {props.list.length} {props.action == ConfirmAction.PrintAllDonorCertificates ? 'donor' : 'voucher holder'} certificates will be printed:</div>

                {props.action == ConfirmAction.PrintAllDonorCertificates && (
                    <div style={{ height: 300, overflowY: 'scroll', marginBottom: 20 }}>
                        <ConfirmTableWrapper bordered condensed striped>
                            <thead>
                                <tr>
                                    <th style={{ width: '10%' }}></th>
                                    <th>Name</th>
                                    <th>Alias</th>
                                    <th>Type</th>
                                    <th>Donation Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(props.list as IAdpDonor[]).map((item, index) =>
                                    <tr key={'d-' + item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.alias}</td>
                                        <td><DonationTypeRenderer donationType={item.donationType} donationTypeAbbr={item.donationTypeAbbr} /></td>
                                        <td>{item.donationDate}</td>
                                    </tr>
                                )}
                            </tbody>
                        </ConfirmTableWrapper>
                    </div>
                )}

                {props.action == ConfirmAction.PrintAllVoucherCertificates && (
                    <div style={{ height: 300, overflowY: 'scroll', marginBottom: 20 }}>
                        <ConfirmTableWrapper bordered condensed striped style={{ marginBottom: 0 }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '10%' }}></th>
                                    <th>Name</th>
                                    <th>Age</th>
                                    <th>Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(props.list as IAdpVoucherHolder[]).map((item, index) =>
                                    <tr key={'d-' + item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.fullName}</td>
                                        <td>{item.age}</td>
                                        <td>{item.type}</td>
                                    </tr>
                                )}
                            </tbody>
                        </ConfirmTableWrapper>
                    </div>
                )}

                <Alert bsStyle='warning' style={{ paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center', marginBottom: 0 }}>{props.message}</Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onYes}>Yes</Button>
                <Button onClick={props.onNo}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmPrint;